import React from "react";

function Sms(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44311 8.57092C7.44311 8.57092 7.40585 7.12132 7.49674 5.73486C7.58772 4.3483 8.38212 3.00688 10.3602 3.03321C10.3602 3.03321 13.7731 2.9291 19.199 3.08954C19.199 3.08954 21.9346 3.10113 21.975 6.21433C21.975 6.21433 21.9849 8.43245 21.9995 10.5358C21.9995 10.5358 21.975 12.5624 19.8949 12.5028C19.8949 12.5028 20.3765 14.7037 20.3329 16.0841C20.3329 16.0841 18.8793 14.5157 16.4704 12.436C16.4704 12.436 16.1574 12.4514 15.1074 12.4093L7.44311 8.57092Z"
        fill="#FFBE32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7251 5.32911C10.7251 5.32911 15.3357 5.32911 18.5792 5.37842C18.5792 5.37842 19.0015 5.37191 18.9719 5.78926C18.9719 5.78926 18.9532 6.273 18.3109 6.26253C17.6686 6.25196 13.9363 6.34031 10.7958 6.31926C10.7958 6.31926 10.2086 6.33319 10.2041 5.79455C10.2041 5.79455 10.1933 5.32728 10.7251 5.32911Z"
        fill="#3C69C6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0267 8.31923C12.0267 8.31923 11.8871 7.5199 12.6225 7.53038C12.6225 7.53038 15.103 7.56718 17.8723 7.5804C17.8723 7.5804 18.5221 7.56088 18.4908 8.16489C18.4908 8.16489 18.5057 8.6529 17.898 8.70008C17.898 8.70008 14.6693 8.76321 12.6326 8.66439C12.6326 8.66439 12.0168 8.68239 12.0267 8.31923Z"
        fill="#3C69C6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00129 10.2966C2.00129 10.2966 1.86037 8.0963 4.52838 8.07821C4.52838 8.07821 8.83856 7.9682 13.5395 8.05198C13.5395 8.05198 15.9576 7.99118 15.9227 10.5941C15.9227 10.5941 15.9048 11.9962 15.8867 14.0503C15.8867 14.0503 16.0345 16.7609 13.2529 16.8431C13.2529 16.8431 11.2289 16.9071 8.30539 16.9071C8.30539 16.9071 7.30681 16.8568 6.36204 18.1938C6.36204 18.1938 5.20265 19.8427 3.75989 20.4738C3.75989 20.4738 4.07656 18.7241 4.12425 16.9572C4.12425 16.9572 2.15408 17.0279 2.06095 14.8194C2.06095 14.8194 2.01604 11.4274 2.00129 10.2966Z"
        fill="#4BCBEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.78742 11.8379C4.78742 11.8379 5.51172 11.8568 5.48553 12.6237C5.48823 13.1149 5.04316 13.3598 4.66827 13.386C4.66827 13.386 4.04818 13.4522 4.00048 12.6176C4.00048 12.6176 3.95342 11.8379 4.78742 11.8379Z"
        fill="#FF9227"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.72794 10.4436C7.72794 10.4436 9.32215 10.3116 9.25538 12.3606C9.25538 12.3606 9.26968 14.1348 7.63256 14.1456C7.63256 14.1456 6.13374 14.1725 6.08605 12.3956C6.08605 12.3956 6.00506 10.4328 7.72794 10.4436Z"
        fill="#FF9227"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8848 11.2724C10.8848 11.2724 11.6793 11.2221 11.6412 12.2007C11.6412 12.2007 11.6854 13.0709 10.8942 13.1033C10.8942 13.1033 10.1889 13.1678 10.1508 12.2632C10.1508 12.2632 10.0841 11.3155 10.8848 11.2724Z"
        fill="#FF9227"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3124 11.4212C13.3124 11.4212 14.0093 11.3935 14.0048 12.2431C14.0048 12.2431 14.0292 13.0236 13.2514 13.0322C13.2514 13.0322 12.5651 13.0667 12.5499 12.2482C12.5499 12.2482 12.5301 11.4039 13.3124 11.4212Z"
        fill="#FF9227"
      />
    </svg>
  );
}

const MemoSms = React.memo(Sms);
export default MemoSms;
